// extracted by mini-css-extract-plugin
export default {"header":"instructionsPage_header__LzKhd","h2":"instructionsPage_h2__gUJcT","p":"instructionsPage_p__0NTlg"};